import React, { useEffect, useState } from "react"
import { withRouter, Link } from "react-router-dom"

import MetaTags from "react-meta-tags"

import { Container } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import PreviewImage from "./PreviewImage"
import {sitename} from "../../../constants/constants";
const Promotions = props => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Admin" breadcrumbItem="SMS Logs" />
        </Container>
        <PreviewImage />
      </div>
    </React.Fragment>
  )
}

export default withRouter(Promotions)
